import React from 'react'
import SubLink from '../../Route/SubLink';
import {ProductsData} from '../../Route/SubLinkJSON';

function ProductsManage() {

  return (
    <>
      <SubLink sublinks={ProductsData} />
    </>
  )
}

export default ProductsManage;
